@if(variant === 'h1'){
<h1 [ngClass]="fontFamily + ' h1 ' + weight" [ngStyle]="{ color: color }">
  {{ text }}
</h1>
} @else if(variant === 'h2'){
<h2 [ngClass]="fontFamily + ' h2 ' + weight" [ngStyle]="{ color: color }">
  {{ text }}
</h2>
} @else if(variant === 'h2-fce'){
<h2 [ngClass]="fontFamily + ' h2-fce ' + weight" [ngStyle]="{ color: color }">
  {{ text }}
</h2>
} @else if(variant === 'h3'){
<h3 [ngClass]="fontFamily + ' h3 ' + weight" [ngStyle]="{ color: color }">
  {{ text }}
</h3>
} @else if(variant === 'h3-fce'){
<h3 [ngClass]="fontFamily + ' h3-fce ' + weight" [ngStyle]="{ color: color }">
  {{ text }}
</h3>
}@else if(variant === 'h4'){
<h4 [ngClass]="fontFamily + ' h4 ' + weight" [ngStyle]="{ color: color }">
  {{ text }}
</h4>
}@else if(variant === 'label' || variant === 'input'){
<p [ngClass]="fontFamily + ' ' + variant + ' regular'" [ngStyle]="{ color: color }">
  {{ text }}
</p>
}@else if(variant === 'button-10' || variant === 'button-20'){
<p [ngClass]="fontFamily + ' ' + variant + ' medium'" [ngStyle]="{ color: color }">
  {{ text }}
</p>
}@else if(variant === 'b1'){
<p
  [ngClass]="fontFamily + ' ' + variant + ' ' + weight + ' ' + moreStyle"
  [ngStyle]="{ color: color }"
>
  {{ text }}

  @if(icon){
  <span
    class="material-symbols-outlined icon"
    [ngStyle]="{ 'vertical-align': 'sub' }"
    [attr.data-icon]="icon"
  >
  </span>
  }
</p>
}@else if(variant === 'h1-d1'){
<h1 [ngClass]="fontFamily + ' d1 ' + weight" [ngStyle]="{ color: color }">
  {{ text }}
</h1>
} @else if(variant === 'li-body-20'){
<span [ngClass]="fontFamily + ' ' + variant + ' ' + weight" [ngStyle]="{ color: color }">
  {{ text }}
</span>
} @else if(variant === 'q' || variant === 'q2'){
<q [ngClass]="fontFamily + ' ' + variant + ' ' + weight" [ngStyle]="{ color: color }">
  {{ text }}
</q>
} @else {
<!-- D1 and assistive variants can have weight = regular or medium -->
<p [ngClass]="fontFamily + ' ' + variant + ' ' + weight" [ngStyle]="{ color: color }">
  {{ text }}
</p>
}
